import React, { useEffect, useState, useCallback } from "react";
import queryString from "query-string";
import Axios from "./../Axios";
import { DownloadOutlined, DesktopOutlined } from "@ant-design/icons";
import { message, Table, Button, DatePicker } from "antd";
import moment from "moment";
import SelectAjax from "../Utils/SelectAjax";
import VideoSplitModal from "../Common/VideoSplitModal";
import { genColumns } from "./Videos/Columns";
import { DrawerShow } from "./Videos/DrawerInfo";

const { RangePicker } = DatePicker;

const Videos = ({ history, location }) => {
  const [video, setVideo] = useState(null);
  const [reviewVisible, setReviewVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({ total: 0 });
  const [videos, setVideos] = useState([]);
  const [filters, setFilters] = useState({});
  const [splitOpen, setSplitOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);

  const fetchVideos = useCallback(async (params = {}) => {
    setIsLoading(true);
    const response = await Axios.get("/videos", {
      params: { results: 10, ...params },
    });

    setPagination({
      total: response.data.meta.total,
      current_page: response.data.meta.current_page,
      last_page: response.data.meta.last_page,
    });

    const updatedVideos = response.data.data.map((v) => {
      if (v.children.length === 0) v.children = null;
      return v;
    });
    setVideos(updatedVideos);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const unlisten = history.listen(() => {
      const parsed = queryString.parse(window.location.search);
      if (parsed.search && parsed.search.length > 0) {
        filterField("search", parsed.search);
      } else {
        fetchVideos();
      }
    });

    const parsed = queryString.parse(location.search);
    if (parsed.search && parsed.search.length > 0) {
      filterField("search", parsed.search);
    } else {
      fetchVideos();
    }

    return () => unlisten();
  }, [fetchVideos, history, location]);

  const download = () => {
    const hide = message.loading(
      "Estamos descargando tu reporte, puede tardar unos minutos...",
      0
    );
    Axios.get("/videos", {
      responseType: "blob",
      params: { export: true, ...filters },
    })
      .then((response) => {
        let blob = new Blob([response.data]);
        hide();
        let url = URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "videos.xlsx";
        a.click();
      })
      .catch(() => {
        hide();
        message.error("Error al exportar documento");
      });
  };

  const checkIsLocked = async (id) => {
    message.loading("Verificando...");
    const res = await Axios.get(`/videos/check-is-locked/${id}`);
    message.destroy();
    return res.data;
  };

  const showVideo = async (video) => {
    video.snaps = [];
    const res = await checkIsLocked(video.id);
    if (!res.success) {
      message.warning(res.message);
      return;
    }
    setReviewVisible(true);

    setVideo(video);
    Axios.get("/videos/" + video.id + "/geocode").then((response) => {
      setVideo(response.data.data);
    });
  };

const closeVideo = () => {
  setVideo(null);
  setReviewVisible(false);
  setCurrentVideo(null)

  console.log("Split finish", {
    ...filters,
    page: pagination.current_page,
  })

  fetchVideos({
    ...filters,
    page: pagination.current_page,
  });
};

  const filterField = (field, value) => {
    const updatedFilters = { ...filters, [field]: value };
    setFilters(updatedFilters);
    fetchVideos(updatedFilters);
  };

  const resetFilters = () => {
    setFilters({});
    fetchVideos({});
  };

  const changeDate = (value) => {
    if (!value) {
      const updatedFilters = { ...filters };
      delete updatedFilters["daterange"];
      setFilters(updatedFilters);
      fetchVideos(updatedFilters);
      return;
    }
    const dates = [
      value[0].format("YYYY-MM-DD"),
      value[1].format("YYYY-MM-DD"),
    ];
    filterField("daterange", dates);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    fetchVideos({
      results: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    });
  };

  const onClickSplit =  async (open, video) => {

    const res = await checkIsLocked(video.id);
    if (!res.success) {
      message.warning(res.message);
      return;
    }

    setSplitOpen(true);
  }

  const columns = genColumns({
    showVideo,
    setSplitOpen:  onClickSplit,
    setCurrentVideo,
  });

  return (
    <>
      <DrawerShow
        closeVideo={closeVideo}
        visible={reviewVisible}
        videoId={video?.id}
      />
      <h1 className="section-title">
        <DesktopOutlined /> Videos para atender
      </h1>

      <div className="filters">
        <RangePicker
          ranges={{
            Hoy: [moment(), moment()],
            Ayer: [
              moment().add(-1, "days").startOf("day"),
              moment().add(-1, "days").endOf("day"),
            ],
            "Este mes": [moment().startOf("month"), moment().endOf("month")],
            "El mes pasado": [
              moment().add(-1, "months").startOf("month"),
              moment().add(-1, "months").endOf("month"),
            ],
            "Ultimos 3 meses": [
              moment().add(-3, "months").startOf("month"),
              moment().add(-3, "months").endOf("month"),
            ],
          }}
          onChange={changeDate}
        />

        <SelectAjax
          value={filters.municipality}
          style={{ width: 200, textAlign: "left" }}
          onChange={(value) => filterField("municipality", value)}
          label={"name"}
          url={"/utils/enabled-places"}
          placeholder="Todos los lugares"
        />

        <SelectAjax
          value={filters.category}
          style={{ width: 240, textAlign: "left" }}
          onChange={(value) => filterField("category", value)}
          label={"name"}
          url={"/utils/enabled-categories"}
          placeholder="Todos las categorías"
        />

        <Button
          type="dashed"
          danger
          style={{ marginLeft: 10, marginRight: 10 }}
          onClick={resetFilters}
        >
          Resetear
        </Button>

        <Button type="primary" onClick={download} icon={<DownloadOutlined />}>
          Exportar
        </Button>
      </div>

      <VideoSplitModal
        visible={splitOpen}
        onClose={() => {
          setSplitOpen(false);
          closeVideo();
        }}
        video={currentVideo}
      />

      <Table
        scroll={{ x: true }}
        showSorterTooltip={true}
        rowClassName={(record) => (record.in_use_at ? "tr-locked" : "")}
        rowKey="id"
        columns={columns}
        dataSource={videos}
        loading={isLoading}
        onChange={handleTableChange}
        footer={() => (
          <div>
            TOTAL PENDIENTES:{" "}
            <b style={{ color: "#00bcd4" }}>{pagination.total}</b>
            <div style={{ float: "right" }}>
              Página {pagination.current_page} / {pagination.last_page}
            </div>
          </div>
        )}
        pagination={pagination}
      />
    </>
  );
};

export default Videos;
